"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TrialsDonutChart_vue_1 = __importDefault(require("./TrialsDonutChart.vue"));
let PageHeadingTrialsConfig = class PageHeadingTrialsConfig extends vue_property_decorator_1.Vue {
    formatLastTimeName(timesObjects) {
        const times = [];
        for (const time of timesObjects) {
            times.push(time.name);
        }
        return times.toString();
    }
    get percentCompleted() {
        let percent = Math.round((this.trialsMeta.totalAssignedSamples / this.trialsMeta.totalSamples) * 100);
        if (percent > 100)
            percent = 100;
        return percent;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], PageHeadingTrialsConfig.prototype, "times", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], PageHeadingTrialsConfig.prototype, "trialsMeta", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], PageHeadingTrialsConfig.prototype, "isLoading", void 0);
PageHeadingTrialsConfig = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            PageHeading: bmk_ui_framework_1.PageHeading,
            TrialsDonutChart: TrialsDonutChart_vue_1.default,
            Loader: bmk_ui_framework_1.Loader
        },
    })
], PageHeadingTrialsConfig);
exports.default = PageHeadingTrialsConfig;
